var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.editor},[_vm._t("menubar",null,{"editor":_vm.editor}),_vm._v(" "),_c('editor-content',{class:_vm.editorContentStyle,attrs:{"editor":_vm.editor}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }